module.exports = __webpack_public_path__ + "static/media/huawei_battery_1.fc2000aa.png";